import type { NewReport } from '@/domain/harvestReports';
import { dayStartISOInTimezone } from '@/utils/date';
import { kilogramsToGrams } from '@/utils/localeFormatters';

export interface FormDataState {
    lastFeedDay: Date | null;
    slaughterDay: Date | null;
    temperature?: number;
    weightMin?: number;
    weightMax?: number;
    isDraft?: boolean;
}

export function parseOptionalKg(value: string): number | undefined {
    if (value === '') {
        return undefined;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
}

function toOptionalGrams(kilograms: number | undefined): number | undefined {
    if (kilograms == null || !Number.isFinite(kilograms)) {
        return undefined;
    }

    return kilogramsToGrams(kilograms);
}

export function areWeightLimitsValid(weightMin?: number, weightMax?: number): boolean {
    if (weightMin != null && weightMin <= 0) {
        return false;
    }

    if (weightMax != null && weightMax <= 0) {
        return false;
    }

    if (weightMin != null && weightMax != null && weightMin >= weightMax) {
        return false;
    }

    return true;
}

/** The report to create from a valid form; weights go from kilograms to grams. */
export function toNewReport(formData: FormDataState): NewReport {
    return {
        // Date columns: the calendar day picked, as UTC midnight, so no zone shifts it.
        lastFeedDay: dayStartISOInTimezone(formData.lastFeedDay),
        slaughterDay: dayStartISOInTimezone(formData.slaughterDay),
        temperature: formData.temperature ?? undefined,
        weight_min: toOptionalGrams(formData.weightMin),
        weight_max: toOptionalGrams(formData.weightMax),
        draft: formData.isDraft ?? false,
    };
}
